module.exports = {
  email: 'alansfuentes@miami.edu',

  socialMedia: [
    {
      name: 'GitHub',
      url: 'https://github.com/Alans44',
    },
    {
      name: 'Instagram',
      url: 'https://www.instagram.com/alanswakes',
    },
    {
      name: 'Linkedin',
      url: 'https://www.linkedin.com/in/alans-fuentes-9770072b1/',
    },
  ],

  navLinks: [
    {
      name: 'About',
      url: '/#about',
    },
    {
      name: 'Experience',
      url: '/#jobs',
    },
    {
      name: 'Projects',
      url: '/#projects',
    },
    {
      name: 'Contact',
      url: '/#contact',
    },
  ],

  colors: {
    green: '#64ffda',
    navy: '#040d10',
    darkNavy: '#020709',
  },

  srConfig: (delay = 200, viewFactor = 0.25) => ({
    origin: 'bottom',
    distance: '20px',
    duration: 500,
    delay,
    rotate: { x: 0, y: 0, z: 0 },
    opacity: 0,
    scale: 1,
    easing: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
    mobile: true,
    reset: false,
    useDelay: 'always',
    viewFactor,
    viewOffset: { top: 0, right: 0, bottom: 0, left: 0 },
  }),
};
